/* eslint-disable */
// @ts-nocheck -- generated AJV standalone code; never edit directly.
// Regenerate: pnpm --filter @cogo/agentic-generator generate:composition-admission-validators
// Sources: @cogo/schema/v4/application-blueprint.cogo.schema.json, @cogo/schema/v4/ux-pattern-definition.cogo.schema.json
import ajvUcs2LengthModule from "ajv/dist/runtime/ucs2length.js";
import ajvEqualModule from "ajv/dist/runtime/equal.js";
const ajvUcs2Length = typeof ajvUcs2LengthModule === "function" ? ajvUcs2LengthModule : ajvUcs2LengthModule.default;
const ajvEqual = typeof ajvEqualModule === "function" ? ajvEqualModule : ajvEqualModule.default;
"use strict";
export const validateApplication = validate20;
const schema31 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"urn:cogo:v4:application-blueprint","type":"object","additionalProperties":false,"required":["schemaVersion","applicationBlueprintId","version","applicationCoreRef","target","locale","recipeRef","userGoal","actor","capabilities","applicationStates","applicationEvents","applicationFlows","datasourceRequirements","applicationPorts","uxInstances","bindings","journey","lineage","runtimeCapabilities"],"properties":{"schemaVersion":{"const":"cogo.application-blueprint.v1"},"applicationBlueprintId":{"$ref":"#/$defs/id"},"version":{"$ref":"#/$defs/version"},"applicationCoreRef":{"type":"string"},"target":{"const":"web"},"locale":{"type":"string","pattern":"^[a-z]{2}-[A-Z]{2}$"},"recipeRef":{"type":"string","pattern":"^cogo:composition-recipe/[A-Za-z0-9._~/-]+$"},"userGoal":{"$ref":"#/$defs/nonEmpty"},"actor":{"$ref":"#/$defs/id"},"capabilities":{"$ref":"#/$defs/uniqueIds"},"applicationStates":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/id"}},"applicationEvents":{"$ref":"#/$defs/uniqueIds"},"applicationFlows":{"type":"array","items":{"$ref":"#/$defs/applicationFlow"}},"datasourceRequirements":{"type":"array","items":{"$ref":"#/$defs/datasourceRequirement"}},"applicationPorts":{"type":"array","items":{"$ref":"#/$defs/port"}},"uxInstances":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/uxInstance"}},"bindings":{"type":"array","items":{"$ref":"#/$defs/binding"}},"journey":{"$ref":"#/$defs/journey"},"lineage":{"$ref":"#/$defs/lineage"},"runtimeCapabilities":{"$ref":"#/$defs/runtimeCapabilities"}},"$defs":{"nonEmpty":{"type":"string","minLength":1},"id":{"type":"string","pattern":"^[a-z][a-z0-9-]*$"},"version":{"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"},"uniqueIds":{"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/id"}},"port":{"type":"object","additionalProperties":false,"required":["portId","kind","direction","valueType","required"],"properties":{"portId":{"$ref":"#/$defs/id"},"kind":{"enum":["data","event","action"]},"direction":{"enum":["in","out"]},"valueType":{"type":"string","pattern":"^cogo\\.[a-z][a-z0-9.-]*$"},"required":{"type":"boolean"}}},"applicationFlow":{"type":"object","additionalProperties":false,"required":["flowId","eventRef","capabilityRef"],"properties":{"flowId":{"$ref":"#/$defs/id"},"eventRef":{"$ref":"#/$defs/id"},"capabilityRef":{"$ref":"#/$defs/id"}}},"datasourceRequirement":{"type":"object","additionalProperties":false,"required":["datasourceId","capabilityRef"],"properties":{"datasourceId":{"$ref":"#/$defs/id"},"capabilityRef":{"$ref":"#/$defs/id"}}},"uxInstance":{"type":"object","additionalProperties":false,"required":["uxInstanceId","definitionRef"],"properties":{"uxInstanceId":{"$ref":"#/$defs/id"},"definitionRef":{"type":"string","pattern":"^[a-z][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"}}},"endpoint":{"type":"object","additionalProperties":false,"required":["scope","portId"],"properties":{"scope":{"enum":["application","ux-instance"]},"uxInstanceId":{"$ref":"#/$defs/id"},"portId":{"$ref":"#/$defs/id"}},"allOf":[{"if":{"properties":{"scope":{"const":"ux-instance"}}},"then":{"required":["uxInstanceId"]},"else":{"not":{"required":["uxInstanceId"]}}}]},"binding":{"type":"object","additionalProperties":false,"required":["bindingId","source","target"],"properties":{"bindingId":{"$ref":"#/$defs/id"},"source":{"$ref":"#/$defs/endpoint"},"target":{"$ref":"#/$defs/endpoint"}}},"journeyTransition":{"type":"object","additionalProperties":false,"required":["eventRef","toStepId","path"],"properties":{"eventRef":{"$ref":"#/$defs/id"},"toStepId":{"$ref":"#/$defs/id"},"path":{"enum":["forward","back","cancel","retry","recovery"]}}},"journeyStep":{"type":"object","additionalProperties":false,"required":["stepId","uxInstanceIds","transitions"],"properties":{"stepId":{"$ref":"#/$defs/id"},"uxInstanceIds":{"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/id"}},"transitions":{"type":"array","items":{"$ref":"#/$defs/journeyTransition"}}}},"journey":{"type":"object","additionalProperties":false,"required":["entryStepId","terminalStepIds","steps"],"properties":{"entryStepId":{"$ref":"#/$defs/id"},"terminalStepIds":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/id"}},"steps":{"type":"array","minItems":2,"items":{"$ref":"#/$defs/journeyStep"}}}},"lineage":{"oneOf":[{"$ref":"#/$defs/canonicalLineage"},{"$ref":"#/$defs/projectValidationLineage"}]},"canonicalLineage":{"type":"object","additionalProperties":false,"required":["authorityStatus","sourceKind","sourceRefs"],"properties":{"authorityStatus":{"const":"consumer-verified"},"sourceKind":{"enum":["application-core","human-authored-canonical"]},"sourceRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"type":"string","pattern":"^cogo:(application-core|approved-source)/[a-z0-9][a-z0-9-]*$"}}}},"projectValidationLineage":{"type":"object","additionalProperties":false,"required":["authorityStatus","sourceKind","sourceRefs"],"properties":{"authorityStatus":{"const":"project-validation"},"sourceKind":{"const":"project-validation-contract"},"sourceRefs":{"type":"array","minItems":1,"maxItems":1,"prefixItems":[{"const":"cogo:project-validation-contract/wonbanking-account-selection-v1"}],"items":false}}},"datasourceToolRef":{"type":"string","pattern":"^datasource:[a-z][a-z0-9-]*$"},"flowToolRef":{"type":"string","pattern":"^flow:[a-z][a-z0-9-]*$"},"webMcpToolRef":{"type":"string","pattern":"^(datasource|flow):[a-z][a-z0-9-]*$"},"approvalPolicyRef":{"type":"string","pattern":"^cogo:approval-policy/[a-z0-9][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"},"runtimeCapabilities":{"type":"object","additionalProperties":false,"required":["webMcp"],"properties":{"webMcp":{"type":"object","additionalProperties":false,"required":["mode","toolRefs","approvalPolicyRef"],"properties":{"mode":{"enum":["disabled","read-only","action-enabled"]},"toolRefs":{"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/webMcpToolRef"}},"approvalPolicyRef":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/approvalPolicyRef"}]}},"allOf":[{"if":{"required":["mode"],"properties":{"mode":{"const":"disabled"}}},"then":{"properties":{"toolRefs":{"maxItems":0},"approvalPolicyRef":{"type":"null"}}}},{"if":{"required":["mode"],"properties":{"mode":{"const":"read-only"}}},"then":{"properties":{"toolRefs":{"minItems":1,"items":{"$ref":"#/$defs/datasourceToolRef"}},"approvalPolicyRef":{"type":"null"}}}},{"if":{"required":["mode"],"properties":{"mode":{"const":"action-enabled"}}},"then":{"properties":{"toolRefs":{"minItems":1,"contains":{"$ref":"#/$defs/flowToolRef"}},"approvalPolicyRef":{"$ref":"#/$defs/approvalPolicyRef"}}}}]}}}},"oneOf":[{"properties":{"applicationCoreRef":{"type":"string","pattern":"^cogo:application-core/[a-z0-9][a-z0-9-]*$"},"lineage":{"$ref":"#/$defs/canonicalLineage"}}},{"properties":{"applicationCoreRef":{"const":"cogo:project-validation-application-core/wonbanking-account-selection-v1"},"lineage":{"$ref":"#/$defs/projectValidationLineage"}}}]};
const schema32 = {"type":"object","additionalProperties":false,"required":["authorityStatus","sourceKind","sourceRefs"],"properties":{"authorityStatus":{"const":"consumer-verified"},"sourceKind":{"enum":["application-core","human-authored-canonical"]},"sourceRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"type":"string","pattern":"^cogo:(application-core|approved-source)/[a-z0-9][a-z0-9-]*$"}}}};
const schema33 = {"type":"object","additionalProperties":false,"required":["authorityStatus","sourceKind","sourceRefs"],"properties":{"authorityStatus":{"const":"project-validation"},"sourceKind":{"const":"project-validation-contract"},"sourceRefs":{"type":"array","minItems":1,"maxItems":1,"prefixItems":[{"const":"cogo:project-validation-contract/wonbanking-account-selection-v1"}],"items":false}}};
const schema34 = {"type":"string","pattern":"^[a-z][a-z0-9-]*$"};
const schema35 = {"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"};
const schema36 = {"type":"string","minLength":1};
const pattern4 = new RegExp("^cogo:application-core/[a-z0-9][a-z0-9-]*$", "u");
const pattern5 = new RegExp("^cogo:(application-core|approved-source)/[a-z0-9][a-z0-9-]*$", "u");
const pattern6 = new RegExp("^[a-z][a-z0-9-]*$", "u");
const pattern7 = new RegExp("^[0-9]+\\.[0-9]+\\.[0-9]+$", "u");
const pattern8 = new RegExp("^[a-z]{2}-[A-Z]{2}$", "u");
const pattern9 = new RegExp("^cogo:composition-recipe/[A-Za-z0-9._~/-]+$", "u");
const func1 = Object.prototype.hasOwnProperty;
const func2 = ajvUcs2Length;
const func0 = ajvEqual;
const schema38 = {"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/id"}};

function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate21.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(Array.isArray(data)){
const len0 = data.length;
for(let i0=0; i0<len0; i0++){
let data0 = data[i0];
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err0 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
else {
const err1 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
let i1 = data.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data[i1], data[j0])){
const err2 = {instancePath,schemaPath:"#/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err3 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
validate21.errors = vErrors;
return errors === 0;
}
validate21.evaluated = {"items":true,"dynamicProps":false,"dynamicItems":false};

const schema41 = {"type":"object","additionalProperties":false,"required":["flowId","eventRef","capabilityRef"],"properties":{"flowId":{"$ref":"#/$defs/id"},"eventRef":{"$ref":"#/$defs/id"},"capabilityRef":{"$ref":"#/$defs/id"}}};

function validate24(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate24.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.flowId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "flowId"},message:"must have required property '"+"flowId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.eventRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "eventRef"},message:"must have required property '"+"eventRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.capabilityRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilityRef"},message:"must have required property '"+"capabilityRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "flowId") || (key0 === "eventRef")) || (key0 === "capabilityRef"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.flowId !== undefined){
let data0 = data.flowId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err4 = {instancePath:instancePath+"/flowId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/flowId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.eventRef !== undefined){
let data1 = data.eventRef;
if(typeof data1 === "string"){
if(!pattern6.test(data1)){
const err6 = {instancePath:instancePath+"/eventRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/eventRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.capabilityRef !== undefined){
let data2 = data.capabilityRef;
if(typeof data2 === "string"){
if(!pattern6.test(data2)){
const err8 = {instancePath:instancePath+"/capabilityRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/capabilityRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate24.errors = vErrors;
return errors === 0;
}
validate24.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema45 = {"type":"object","additionalProperties":false,"required":["datasourceId","capabilityRef"],"properties":{"datasourceId":{"$ref":"#/$defs/id"},"capabilityRef":{"$ref":"#/$defs/id"}}};

function validate26(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate26.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.datasourceId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "datasourceId"},message:"must have required property '"+"datasourceId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.capabilityRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilityRef"},message:"must have required property '"+"capabilityRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "datasourceId") || (key0 === "capabilityRef"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.datasourceId !== undefined){
let data0 = data.datasourceId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err3 = {instancePath:instancePath+"/datasourceId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/datasourceId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.capabilityRef !== undefined){
let data1 = data.capabilityRef;
if(typeof data1 === "string"){
if(!pattern6.test(data1)){
const err5 = {instancePath:instancePath+"/capabilityRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/capabilityRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
validate26.errors = vErrors;
return errors === 0;
}
validate26.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema48 = {"type":"object","additionalProperties":false,"required":["portId","kind","direction","valueType","required"],"properties":{"portId":{"$ref":"#/$defs/id"},"kind":{"enum":["data","event","action"]},"direction":{"enum":["in","out"]},"valueType":{"type":"string","pattern":"^cogo\\.[a-z][a-z0-9.-]*$"},"required":{"type":"boolean"}}};
const pattern19 = new RegExp("^cogo\\.[a-z][a-z0-9.-]*$", "u");

function validate28(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate28.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.portId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "portId"},message:"must have required property '"+"portId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.direction === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "direction"},message:"must have required property '"+"direction"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.valueType === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "valueType"},message:"must have required property '"+"valueType"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.required === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "required"},message:"must have required property '"+"required"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "portId") || (key0 === "kind")) || (key0 === "direction")) || (key0 === "valueType")) || (key0 === "required"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.portId !== undefined){
let data0 = data.portId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err6 = {instancePath:instancePath+"/portId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/portId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(!(((data1 === "data") || (data1 === "event")) || (data1 === "action"))){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema48.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.direction !== undefined){
let data2 = data.direction;
if(!((data2 === "in") || (data2 === "out"))){
const err9 = {instancePath:instancePath+"/direction",schemaPath:"#/properties/direction/enum",keyword:"enum",params:{allowedValues: schema48.properties.direction.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.valueType !== undefined){
let data3 = data.valueType;
if(typeof data3 === "string"){
if(!pattern19.test(data3)){
const err10 = {instancePath:instancePath+"/valueType",schemaPath:"#/properties/valueType/pattern",keyword:"pattern",params:{pattern: "^cogo\\.[a-z][a-z0-9.-]*$"},message:"must match pattern \""+"^cogo\\.[a-z][a-z0-9.-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/valueType",schemaPath:"#/properties/valueType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.required !== undefined){
if(typeof data.required !== "boolean"){
const err12 = {instancePath:instancePath+"/required",schemaPath:"#/properties/required/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate28.errors = vErrors;
return errors === 0;
}
validate28.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema50 = {"type":"object","additionalProperties":false,"required":["uxInstanceId","definitionRef"],"properties":{"uxInstanceId":{"$ref":"#/$defs/id"},"definitionRef":{"type":"string","pattern":"^[a-z][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"}}};
const pattern21 = new RegExp("^[a-z][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$", "u");

function validate30(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate30.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.uxInstanceId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "uxInstanceId"},message:"must have required property '"+"uxInstanceId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.definitionRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "definitionRef"},message:"must have required property '"+"definitionRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "uxInstanceId") || (key0 === "definitionRef"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.uxInstanceId !== undefined){
let data0 = data.uxInstanceId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err3 = {instancePath:instancePath+"/uxInstanceId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/uxInstanceId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.definitionRef !== undefined){
let data1 = data.definitionRef;
if(typeof data1 === "string"){
if(!pattern21.test(data1)){
const err5 = {instancePath:instancePath+"/definitionRef",schemaPath:"#/properties/definitionRef/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/definitionRef",schemaPath:"#/properties/definitionRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
validate30.errors = vErrors;
return errors === 0;
}
validate30.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema52 = {"type":"object","additionalProperties":false,"required":["bindingId","source","target"],"properties":{"bindingId":{"$ref":"#/$defs/id"},"source":{"$ref":"#/$defs/endpoint"},"target":{"$ref":"#/$defs/endpoint"}}};
const schema54 = {"type":"object","additionalProperties":false,"required":["scope","portId"],"properties":{"scope":{"enum":["application","ux-instance"]},"uxInstanceId":{"$ref":"#/$defs/id"},"portId":{"$ref":"#/$defs/id"}},"allOf":[{"if":{"properties":{"scope":{"const":"ux-instance"}}},"then":{"required":["uxInstanceId"]},"else":{"not":{"required":["uxInstanceId"]}}}]};

function validate33(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate33.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs2 = errors;
let valid1 = true;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.scope !== undefined){
if("ux-instance" !== data.scope){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
var _valid0 = _errs3 === errors;
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
let ifClause0;
if(_valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.uxInstanceId === undefined){
const err1 = {instancePath,schemaPath:"#/allOf/0/then/required",keyword:"required",params:{missingProperty: "uxInstanceId"},message:"must have required property '"+"uxInstanceId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid1 = _valid0;
ifClause0 = "then";
}
else {
const _errs6 = errors;
const _errs7 = errors;
const _errs8 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.uxInstanceId === undefined) && (missing0 = "uxInstanceId")){
const err2 = {};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var valid3 = _errs8 === errors;
if(valid3){
const err3 = {instancePath,schemaPath:"#/allOf/0/else/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
else {
errors = _errs7;
if(vErrors !== null){
if(_errs7){
vErrors.length = _errs7;
}
else {
vErrors = null;
}
}
}
var _valid0 = _errs6 === errors;
valid1 = _valid0;
ifClause0 = "else";
}
if(!valid1){
const err4 = {instancePath,schemaPath:"#/allOf/0/if",keyword:"if",params:{failingKeyword: ifClause0},message:"must match \""+ifClause0+"\" schema"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.scope === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "scope"},message:"must have required property '"+"scope"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.portId === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "portId"},message:"must have required property '"+"portId"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "scope") || (key0 === "uxInstanceId")) || (key0 === "portId"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.scope !== undefined){
let data1 = data.scope;
if(!((data1 === "application") || (data1 === "ux-instance"))){
const err8 = {instancePath:instancePath+"/scope",schemaPath:"#/properties/scope/enum",keyword:"enum",params:{allowedValues: schema54.properties.scope.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.uxInstanceId !== undefined){
let data2 = data.uxInstanceId;
if(typeof data2 === "string"){
if(!pattern6.test(data2)){
const err9 = {instancePath:instancePath+"/uxInstanceId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/uxInstanceId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.portId !== undefined){
let data3 = data.portId;
if(typeof data3 === "string"){
if(!pattern6.test(data3)){
const err11 = {instancePath:instancePath+"/portId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/portId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate33.errors = vErrors;
return errors === 0;
}
validate33.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate32(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate32.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.bindingId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bindingId"},message:"must have required property '"+"bindingId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.source === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.target === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "bindingId") || (key0 === "source")) || (key0 === "target"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.bindingId !== undefined){
let data0 = data.bindingId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err4 = {instancePath:instancePath+"/bindingId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/bindingId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.source !== undefined){
if(!(validate33(data.source, {instancePath:instancePath+"/source",parentData:data,parentDataProperty:"source",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate33.errors : vErrors.concat(validate33.errors);
errors = vErrors.length;
}
}
if(data.target !== undefined){
if(!(validate33(data.target, {instancePath:instancePath+"/target",parentData:data,parentDataProperty:"target",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate33.errors : vErrors.concat(validate33.errors);
errors = vErrors.length;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate32.errors = vErrors;
return errors === 0;
}
validate32.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema57 = {"type":"object","additionalProperties":false,"required":["entryStepId","terminalStepIds","steps"],"properties":{"entryStepId":{"$ref":"#/$defs/id"},"terminalStepIds":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/id"}},"steps":{"type":"array","minItems":2,"items":{"$ref":"#/$defs/journeyStep"}}}};
const schema60 = {"type":"object","additionalProperties":false,"required":["stepId","uxInstanceIds","transitions"],"properties":{"stepId":{"$ref":"#/$defs/id"},"uxInstanceIds":{"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/id"}},"transitions":{"type":"array","items":{"$ref":"#/$defs/journeyTransition"}}}};
const schema63 = {"type":"object","additionalProperties":false,"required":["eventRef","toStepId","path"],"properties":{"eventRef":{"$ref":"#/$defs/id"},"toStepId":{"$ref":"#/$defs/id"},"path":{"enum":["forward","back","cancel","retry","recovery"]}}};

function validate39(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate39.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.eventRef === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "eventRef"},message:"must have required property '"+"eventRef"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.toStepId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "toStepId"},message:"must have required property '"+"toStepId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.path === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "path"},message:"must have required property '"+"path"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "eventRef") || (key0 === "toStepId")) || (key0 === "path"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.eventRef !== undefined){
let data0 = data.eventRef;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err4 = {instancePath:instancePath+"/eventRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/eventRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.toStepId !== undefined){
let data1 = data.toStepId;
if(typeof data1 === "string"){
if(!pattern6.test(data1)){
const err6 = {instancePath:instancePath+"/toStepId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/toStepId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.path !== undefined){
let data2 = data.path;
if(!(((((data2 === "forward") || (data2 === "back")) || (data2 === "cancel")) || (data2 === "retry")) || (data2 === "recovery"))){
const err8 = {instancePath:instancePath+"/path",schemaPath:"#/properties/path/enum",keyword:"enum",params:{allowedValues: schema63.properties.path.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate39.errors = vErrors;
return errors === 0;
}
validate39.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate38(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate38.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.stepId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "stepId"},message:"must have required property '"+"stepId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.uxInstanceIds === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "uxInstanceIds"},message:"must have required property '"+"uxInstanceIds"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.transitions === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "transitions"},message:"must have required property '"+"transitions"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "stepId") || (key0 === "uxInstanceIds")) || (key0 === "transitions"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.stepId !== undefined){
let data0 = data.stepId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err4 = {instancePath:instancePath+"/stepId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/stepId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.uxInstanceIds !== undefined){
let data1 = data.uxInstanceIds;
if(Array.isArray(data1)){
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if(typeof data2 === "string"){
if(!pattern6.test(data2)){
const err6 = {instancePath:instancePath+"/uxInstanceIds/" + i0,schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/uxInstanceIds/" + i0,schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
let i1 = data1.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data1[i1], data1[j0])){
const err8 = {instancePath:instancePath+"/uxInstanceIds",schemaPath:"#/properties/uxInstanceIds/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err9 = {instancePath:instancePath+"/uxInstanceIds",schemaPath:"#/properties/uxInstanceIds/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.transitions !== undefined){
let data3 = data.transitions;
if(Array.isArray(data3)){
const len1 = data3.length;
for(let i2=0; i2<len1; i2++){
if(!(validate39(data3[i2], {instancePath:instancePath+"/transitions/" + i2,parentData:data3,parentDataProperty:i2,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
errors = vErrors.length;
}
}
}
else {
const err10 = {instancePath:instancePath+"/transitions",schemaPath:"#/properties/transitions/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
else {
const err11 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
validate38.errors = vErrors;
return errors === 0;
}
validate38.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate37(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate37.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.entryStepId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "entryStepId"},message:"must have required property '"+"entryStepId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.terminalStepIds === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "terminalStepIds"},message:"must have required property '"+"terminalStepIds"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.steps === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "steps"},message:"must have required property '"+"steps"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "entryStepId") || (key0 === "terminalStepIds")) || (key0 === "steps"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.entryStepId !== undefined){
let data0 = data.entryStepId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err4 = {instancePath:instancePath+"/entryStepId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/entryStepId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.terminalStepIds !== undefined){
let data1 = data.terminalStepIds;
if(Array.isArray(data1)){
if(data1.length < 1){
const err6 = {instancePath:instancePath+"/terminalStepIds",schemaPath:"#/properties/terminalStepIds/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if(typeof data2 === "string"){
if(!pattern6.test(data2)){
const err7 = {instancePath:instancePath+"/terminalStepIds/" + i0,schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/terminalStepIds/" + i0,schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
let i1 = data1.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data1[i1], data1[j0])){
const err9 = {instancePath:instancePath+"/terminalStepIds",schemaPath:"#/properties/terminalStepIds/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err10 = {instancePath:instancePath+"/terminalStepIds",schemaPath:"#/properties/terminalStepIds/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.steps !== undefined){
let data3 = data.steps;
if(Array.isArray(data3)){
if(data3.length < 2){
const err11 = {instancePath:instancePath+"/steps",schemaPath:"#/properties/steps/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
const len1 = data3.length;
for(let i2=0; i2<len1; i2++){
if(!(validate38(data3[i2], {instancePath:instancePath+"/steps/" + i2,parentData:data3,parentDataProperty:i2,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
errors = vErrors.length;
}
}
}
else {
const err12 = {instancePath:instancePath+"/steps",schemaPath:"#/properties/steps/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate37.errors = vErrors;
return errors === 0;
}
validate37.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema66 = {"oneOf":[{"$ref":"#/$defs/canonicalLineage"},{"$ref":"#/$defs/projectValidationLineage"}]};

function validate43(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate43.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authorityStatus === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/canonicalLineage/required",keyword:"required",params:{missingProperty: "authorityStatus"},message:"must have required property '"+"authorityStatus"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.sourceKind === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/canonicalLineage/required",keyword:"required",params:{missingProperty: "sourceKind"},message:"must have required property '"+"sourceKind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.sourceRefs === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/canonicalLineage/required",keyword:"required",params:{missingProperty: "sourceRefs"},message:"must have required property '"+"sourceRefs"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "authorityStatus") || (key0 === "sourceKind")) || (key0 === "sourceRefs"))){
const err3 = {instancePath,schemaPath:"#/$defs/canonicalLineage/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.authorityStatus !== undefined){
if("consumer-verified" !== data.authorityStatus){
const err4 = {instancePath:instancePath+"/authorityStatus",schemaPath:"#/$defs/canonicalLineage/properties/authorityStatus/const",keyword:"const",params:{allowedValue: "consumer-verified"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.sourceKind !== undefined){
let data1 = data.sourceKind;
if(!((data1 === "application-core") || (data1 === "human-authored-canonical"))){
const err5 = {instancePath:instancePath+"/sourceKind",schemaPath:"#/$defs/canonicalLineage/properties/sourceKind/enum",keyword:"enum",params:{allowedValues: schema32.properties.sourceKind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.sourceRefs !== undefined){
let data2 = data.sourceRefs;
if(Array.isArray(data2)){
if(data2.length < 1){
const err6 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
let data3 = data2[i0];
if(typeof data3 === "string"){
if(!pattern5.test(data3)){
const err7 = {instancePath:instancePath+"/sourceRefs/" + i0,schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/items/pattern",keyword:"pattern",params:{pattern: "^cogo:(application-core|approved-source)/[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^cogo:(application-core|approved-source)/[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/sourceRefs/" + i0,schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
let i1 = data2.length;
let j0;
if(i1 > 1){
const indices0 = {};
for(;i1--;){
let item0 = data2[i1];
if(typeof item0 !== "string"){
continue;
}
if(typeof indices0[item0] == "number"){
j0 = indices0[item0];
const err9 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
break;
}
indices0[item0] = i1;
}
}
}
else {
const err10 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
else {
const err11 = {instancePath,schemaPath:"#/$defs/canonicalLineage/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs11 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authorityStatus === undefined){
const err12 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/required",keyword:"required",params:{missingProperty: "authorityStatus"},message:"must have required property '"+"authorityStatus"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.sourceKind === undefined){
const err13 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/required",keyword:"required",params:{missingProperty: "sourceKind"},message:"must have required property '"+"sourceKind"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data.sourceRefs === undefined){
const err14 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/required",keyword:"required",params:{missingProperty: "sourceRefs"},message:"must have required property '"+"sourceRefs"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
for(const key1 in data){
if(!(((key1 === "authorityStatus") || (key1 === "sourceKind")) || (key1 === "sourceRefs"))){
const err15 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.authorityStatus !== undefined){
if("project-validation" !== data.authorityStatus){
const err16 = {instancePath:instancePath+"/authorityStatus",schemaPath:"#/$defs/projectValidationLineage/properties/authorityStatus/const",keyword:"const",params:{allowedValue: "project-validation"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.sourceKind !== undefined){
if("project-validation-contract" !== data.sourceKind){
const err17 = {instancePath:instancePath+"/sourceKind",schemaPath:"#/$defs/projectValidationLineage/properties/sourceKind/const",keyword:"const",params:{allowedValue: "project-validation-contract"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.sourceRefs !== undefined){
let data6 = data.sourceRefs;
if(Array.isArray(data6)){
if(data6.length > 1){
const err18 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/maxItems",keyword:"maxItems",params:{limit: 1},message:"must NOT have more than 1 items"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data6.length < 1){
const err19 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
const len1 = data6.length;
if(len1 > 0){
if("cogo:project-validation-contract/wonbanking-account-selection-v1" !== data6[0]){
const err20 = {instancePath:instancePath+"/sourceRefs/0",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/prefixItems/0/const",keyword:"const",params:{allowedValue: "cogo:project-validation-contract/wonbanking-account-selection-v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
const len2 = data6.length;
if(!(len2 <= 1)){
const err21 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/items",keyword:"items",params:{limit: 1},message:"must NOT have more than 1 items"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
var _valid0 = _errs11 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err24 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate43.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate43.evaluated = {"dynamicProps":true,"dynamicItems":false};

const schema69 = {"type":"object","additionalProperties":false,"required":["webMcp"],"properties":{"webMcp":{"type":"object","additionalProperties":false,"required":["mode","toolRefs","approvalPolicyRef"],"properties":{"mode":{"enum":["disabled","read-only","action-enabled"]},"toolRefs":{"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/webMcpToolRef"}},"approvalPolicyRef":{"oneOf":[{"type":"null"},{"$ref":"#/$defs/approvalPolicyRef"}]}},"allOf":[{"if":{"required":["mode"],"properties":{"mode":{"const":"disabled"}}},"then":{"properties":{"toolRefs":{"maxItems":0},"approvalPolicyRef":{"type":"null"}}}},{"if":{"required":["mode"],"properties":{"mode":{"const":"read-only"}}},"then":{"properties":{"toolRefs":{"minItems":1,"items":{"$ref":"#/$defs/datasourceToolRef"}},"approvalPolicyRef":{"type":"null"}}}},{"if":{"required":["mode"],"properties":{"mode":{"const":"action-enabled"}}},"then":{"properties":{"toolRefs":{"minItems":1,"contains":{"$ref":"#/$defs/flowToolRef"}},"approvalPolicyRef":{"$ref":"#/$defs/approvalPolicyRef"}}}}]}}};
const schema70 = {"type":"string","pattern":"^datasource:[a-z][a-z0-9-]*$"};
const schema71 = {"type":"string","pattern":"^flow:[a-z][a-z0-9-]*$"};
const schema72 = {"type":"string","pattern":"^cogo:approval-policy/[a-z0-9][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"};
const schema73 = {"type":"string","pattern":"^(datasource|flow):[a-z][a-z0-9-]*$"};
const pattern32 = new RegExp("^datasource:[a-z][a-z0-9-]*$", "u");
const pattern33 = new RegExp("^flow:[a-z][a-z0-9-]*$", "u");
const pattern34 = new RegExp("^cogo:approval-policy/[a-z0-9][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$", "u");
const pattern35 = new RegExp("^(datasource|flow):[a-z][a-z0-9-]*$", "u");

function validate45(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate45.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.webMcp === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "webMcp"},message:"must have required property '"+"webMcp"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "webMcp")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.webMcp !== undefined){
let data0 = data.webMcp;
const _errs5 = errors;
let valid2 = true;
const _errs6 = errors;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
let missing0;
if((data0.mode === undefined) && (missing0 = "mode")){
const err2 = {};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
else {
if(data0.mode !== undefined){
if("disabled" !== data0.mode){
const err3 = {};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
}
var _valid0 = _errs6 === errors;
errors = _errs5;
if(vErrors !== null){
if(_errs5){
vErrors.length = _errs5;
}
else {
vErrors = null;
}
}
if(_valid0){
const _errs8 = errors;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.toolRefs !== undefined){
let data2 = data0.toolRefs;
if(Array.isArray(data2)){
if(data2.length > 0){
const err4 = {instancePath:instancePath+"/webMcp/toolRefs",schemaPath:"#/properties/webMcp/allOf/0/then/properties/toolRefs/maxItems",keyword:"maxItems",params:{limit: 0},message:"must NOT have more than 0 items"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
if(data0.approvalPolicyRef !== undefined){
if(data0.approvalPolicyRef !== null){
const err5 = {instancePath:instancePath+"/webMcp/approvalPolicyRef",schemaPath:"#/properties/webMcp/allOf/0/then/properties/approvalPolicyRef/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
var _valid0 = _errs8 === errors;
valid2 = _valid0;
if(valid2){
var props0 = {};
props0.toolRefs = true;
props0.approvalPolicyRef = true;
props0.mode = true;
}
}
if(!valid2){
const err6 = {instancePath:instancePath+"/webMcp",schemaPath:"#/properties/webMcp/allOf/0/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
const _errs13 = errors;
let valid5 = true;
const _errs14 = errors;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
let missing1;
if((data0.mode === undefined) && (missing1 = "mode")){
const err7 = {};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
else {
if(data0.mode !== undefined){
if("read-only" !== data0.mode){
const err8 = {};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
}
var _valid1 = _errs14 === errors;
errors = _errs13;
if(vErrors !== null){
if(_errs13){
vErrors.length = _errs13;
}
else {
vErrors = null;
}
}
if(_valid1){
const _errs16 = errors;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.toolRefs !== undefined){
let data5 = data0.toolRefs;
if(Array.isArray(data5)){
if(data5.length < 1){
const err9 = {instancePath:instancePath+"/webMcp/toolRefs",schemaPath:"#/properties/webMcp/allOf/1/then/properties/toolRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
const len0 = data5.length;
for(let i0=0; i0<len0; i0++){
let data6 = data5[i0];
if(typeof data6 === "string"){
if(!pattern32.test(data6)){
const err10 = {instancePath:instancePath+"/webMcp/toolRefs/" + i0,schemaPath:"#/$defs/datasourceToolRef/pattern",keyword:"pattern",params:{pattern: "^datasource:[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^datasource:[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/webMcp/toolRefs/" + i0,schemaPath:"#/$defs/datasourceToolRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
}
if(data0.approvalPolicyRef !== undefined){
if(data0.approvalPolicyRef !== null){
const err12 = {instancePath:instancePath+"/webMcp/approvalPolicyRef",schemaPath:"#/properties/webMcp/allOf/1/then/properties/approvalPolicyRef/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
var _valid1 = _errs16 === errors;
valid5 = _valid1;
if(valid5){
var props1 = {};
props1.toolRefs = true;
props1.approvalPolicyRef = true;
props1.mode = true;
}
}
if(!valid5){
const err13 = {instancePath:instancePath+"/webMcp",schemaPath:"#/properties/webMcp/allOf/1/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(props0 !== true && props1 !== undefined){
if(props1 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props1);
}
}
const _errs24 = errors;
let valid11 = true;
const _errs25 = errors;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
let missing2;
if((data0.mode === undefined) && (missing2 = "mode")){
const err14 = {};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
else {
if(data0.mode !== undefined){
if("action-enabled" !== data0.mode){
const err15 = {};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
}
var _valid2 = _errs25 === errors;
errors = _errs24;
if(vErrors !== null){
if(_errs24){
vErrors.length = _errs24;
}
else {
vErrors = null;
}
}
if(_valid2){
const _errs27 = errors;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.toolRefs !== undefined){
let data9 = data0.toolRefs;
if(Array.isArray(data9)){
if(data9.length < 1){
const err16 = {instancePath:instancePath+"/webMcp/toolRefs",schemaPath:"#/properties/webMcp/allOf/2/then/properties/toolRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
const _errs29 = errors;
const len1 = data9.length;
for(let i1=0; i1<len1; i1++){
let data10 = data9[i1];
const _errs30 = errors;
if(typeof data10 === "string"){
if(!pattern33.test(data10)){
const err17 = {instancePath:instancePath+"/webMcp/toolRefs/" + i1,schemaPath:"#/$defs/flowToolRef/pattern",keyword:"pattern",params:{pattern: "^flow:[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^flow:[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/webMcp/toolRefs/" + i1,schemaPath:"#/$defs/flowToolRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
var valid14 = _errs30 === errors;
if(valid14){
break;
}
}
if(!valid14){
const err19 = {instancePath:instancePath+"/webMcp/toolRefs",schemaPath:"#/properties/webMcp/allOf/2/then/properties/toolRefs/contains",keyword:"contains",params:{minContains: 1},message:"must contain at least 1 valid item(s)"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
else {
errors = _errs29;
if(vErrors !== null){
if(_errs29){
vErrors.length = _errs29;
}
else {
vErrors = null;
}
}
}
}
}
if(data0.approvalPolicyRef !== undefined){
let data11 = data0.approvalPolicyRef;
if(typeof data11 === "string"){
if(!pattern34.test(data11)){
const err20 = {instancePath:instancePath+"/webMcp/approvalPolicyRef",schemaPath:"#/$defs/approvalPolicyRef/pattern",keyword:"pattern",params:{pattern: "^cogo:approval-policy/[a-z0-9][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^cogo:approval-policy/[a-z0-9][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/webMcp/approvalPolicyRef",schemaPath:"#/$defs/approvalPolicyRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
var _valid2 = _errs27 === errors;
valid11 = _valid2;
if(valid11){
var props2 = {};
props2.toolRefs = true;
props2.approvalPolicyRef = true;
props2.mode = true;
}
}
if(!valid11){
const err22 = {instancePath:instancePath+"/webMcp",schemaPath:"#/properties/webMcp/allOf/2/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(props0 !== true && props2 !== undefined){
if(props2 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props2);
}
}
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.mode === undefined){
const err23 = {instancePath:instancePath+"/webMcp",schemaPath:"#/properties/webMcp/required",keyword:"required",params:{missingProperty: "mode"},message:"must have required property '"+"mode"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data0.toolRefs === undefined){
const err24 = {instancePath:instancePath+"/webMcp",schemaPath:"#/properties/webMcp/required",keyword:"required",params:{missingProperty: "toolRefs"},message:"must have required property '"+"toolRefs"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data0.approvalPolicyRef === undefined){
const err25 = {instancePath:instancePath+"/webMcp",schemaPath:"#/properties/webMcp/required",keyword:"required",params:{missingProperty: "approvalPolicyRef"},message:"must have required property '"+"approvalPolicyRef"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
for(const key1 in data0){
if(!(((key1 === "mode") || (key1 === "toolRefs")) || (key1 === "approvalPolicyRef"))){
const err26 = {instancePath:instancePath+"/webMcp",schemaPath:"#/properties/webMcp/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data0.mode !== undefined){
let data12 = data0.mode;
if(!(((data12 === "disabled") || (data12 === "read-only")) || (data12 === "action-enabled"))){
const err27 = {instancePath:instancePath+"/webMcp/mode",schemaPath:"#/properties/webMcp/properties/mode/enum",keyword:"enum",params:{allowedValues: schema69.properties.webMcp.properties.mode.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data0.toolRefs !== undefined){
let data13 = data0.toolRefs;
if(Array.isArray(data13)){
const len2 = data13.length;
for(let i2=0; i2<len2; i2++){
let data14 = data13[i2];
if(typeof data14 === "string"){
if(!pattern35.test(data14)){
const err28 = {instancePath:instancePath+"/webMcp/toolRefs/" + i2,schemaPath:"#/$defs/webMcpToolRef/pattern",keyword:"pattern",params:{pattern: "^(datasource|flow):[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^(datasource|flow):[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/webMcp/toolRefs/" + i2,schemaPath:"#/$defs/webMcpToolRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
let i3 = data13.length;
let j0;
if(i3 > 1){
outer0:
for(;i3--;){
for(j0 = i3; j0--;){
if(func0(data13[i3], data13[j0])){
const err30 = {instancePath:instancePath+"/webMcp/toolRefs",schemaPath:"#/properties/webMcp/properties/toolRefs/uniqueItems",keyword:"uniqueItems",params:{i: i3, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i3+" are identical)"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err31 = {instancePath:instancePath+"/webMcp/toolRefs",schemaPath:"#/properties/webMcp/properties/toolRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data0.approvalPolicyRef !== undefined){
let data15 = data0.approvalPolicyRef;
const _errs44 = errors;
let valid22 = false;
let passing0 = null;
const _errs45 = errors;
if(data15 !== null){
const err32 = {instancePath:instancePath+"/webMcp/approvalPolicyRef",schemaPath:"#/properties/webMcp/properties/approvalPolicyRef/oneOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
var _valid3 = _errs45 === errors;
if(_valid3){
valid22 = true;
passing0 = 0;
}
const _errs47 = errors;
if(typeof data15 === "string"){
if(!pattern34.test(data15)){
const err33 = {instancePath:instancePath+"/webMcp/approvalPolicyRef",schemaPath:"#/$defs/approvalPolicyRef/pattern",keyword:"pattern",params:{pattern: "^cogo:approval-policy/[a-z0-9][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^cogo:approval-policy/[a-z0-9][a-z0-9-]*@[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
else {
const err34 = {instancePath:instancePath+"/webMcp/approvalPolicyRef",schemaPath:"#/$defs/approvalPolicyRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
var _valid3 = _errs47 === errors;
if(_valid3 && valid22){
valid22 = false;
passing0 = [passing0, 1];
}
else {
if(_valid3){
valid22 = true;
passing0 = 1;
}
}
if(!valid22){
const err35 = {instancePath:instancePath+"/webMcp/approvalPolicyRef",schemaPath:"#/properties/webMcp/properties/approvalPolicyRef/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
else {
errors = _errs44;
if(vErrors !== null){
if(_errs44){
vErrors.length = _errs44;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err36 = {instancePath:instancePath+"/webMcp",schemaPath:"#/properties/webMcp/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
else {
const err37 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
validate45.errors = vErrors;
return errors === 0;
}
validate45.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate20(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="urn:cogo:v4:application-blueprint" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate20.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs1 = errors;
let valid0 = false;
let passing0 = null;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.applicationCoreRef !== undefined){
let data0 = data.applicationCoreRef;
if(typeof data0 === "string"){
if(!pattern4.test(data0)){
const err0 = {instancePath:instancePath+"/applicationCoreRef",schemaPath:"#/oneOf/0/properties/applicationCoreRef/pattern",keyword:"pattern",params:{pattern: "^cogo:application-core/[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^cogo:application-core/[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
else {
const err1 = {instancePath:instancePath+"/applicationCoreRef",schemaPath:"#/oneOf/0/properties/applicationCoreRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.lineage !== undefined){
let data1 = data.lineage;
if(data1 && typeof data1 == "object" && !Array.isArray(data1)){
if(data1.authorityStatus === undefined){
const err2 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/canonicalLineage/required",keyword:"required",params:{missingProperty: "authorityStatus"},message:"must have required property '"+"authorityStatus"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data1.sourceKind === undefined){
const err3 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/canonicalLineage/required",keyword:"required",params:{missingProperty: "sourceKind"},message:"must have required property '"+"sourceKind"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data1.sourceRefs === undefined){
const err4 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/canonicalLineage/required",keyword:"required",params:{missingProperty: "sourceRefs"},message:"must have required property '"+"sourceRefs"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data1){
if(!(((key0 === "authorityStatus") || (key0 === "sourceKind")) || (key0 === "sourceRefs"))){
const err5 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/canonicalLineage/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data1.authorityStatus !== undefined){
if("consumer-verified" !== data1.authorityStatus){
const err6 = {instancePath:instancePath+"/lineage/authorityStatus",schemaPath:"#/$defs/canonicalLineage/properties/authorityStatus/const",keyword:"const",params:{allowedValue: "consumer-verified"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data1.sourceKind !== undefined){
let data3 = data1.sourceKind;
if(!((data3 === "application-core") || (data3 === "human-authored-canonical"))){
const err7 = {instancePath:instancePath+"/lineage/sourceKind",schemaPath:"#/$defs/canonicalLineage/properties/sourceKind/enum",keyword:"enum",params:{allowedValues: schema32.properties.sourceKind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data1.sourceRefs !== undefined){
let data4 = data1.sourceRefs;
if(Array.isArray(data4)){
if(data4.length < 1){
const err8 = {instancePath:instancePath+"/lineage/sourceRefs",schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
const len0 = data4.length;
for(let i0=0; i0<len0; i0++){
let data5 = data4[i0];
if(typeof data5 === "string"){
if(!pattern5.test(data5)){
const err9 = {instancePath:instancePath+"/lineage/sourceRefs/" + i0,schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/items/pattern",keyword:"pattern",params:{pattern: "^cogo:(application-core|approved-source)/[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^cogo:(application-core|approved-source)/[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/lineage/sourceRefs/" + i0,schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
let i1 = data4.length;
let j0;
if(i1 > 1){
const indices0 = {};
for(;i1--;){
let item0 = data4[i1];
if(typeof item0 !== "string"){
continue;
}
if(typeof indices0[item0] == "number"){
j0 = indices0[item0];
const err11 = {instancePath:instancePath+"/lineage/sourceRefs",schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
break;
}
indices0[item0] = i1;
}
}
}
else {
const err12 = {instancePath:instancePath+"/lineage/sourceRefs",schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/canonicalLineage/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
var _valid0 = _errs2 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = {};
props0.applicationCoreRef = true;
props0.lineage = true;
}
const _errs15 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.applicationCoreRef !== undefined){
if("cogo:project-validation-application-core/wonbanking-account-selection-v1" !== data.applicationCoreRef){
const err14 = {instancePath:instancePath+"/applicationCoreRef",schemaPath:"#/oneOf/1/properties/applicationCoreRef/const",keyword:"const",params:{allowedValue: "cogo:project-validation-application-core/wonbanking-account-selection-v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.lineage !== undefined){
let data7 = data.lineage;
if(data7 && typeof data7 == "object" && !Array.isArray(data7)){
if(data7.authorityStatus === undefined){
const err15 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/projectValidationLineage/required",keyword:"required",params:{missingProperty: "authorityStatus"},message:"must have required property '"+"authorityStatus"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data7.sourceKind === undefined){
const err16 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/projectValidationLineage/required",keyword:"required",params:{missingProperty: "sourceKind"},message:"must have required property '"+"sourceKind"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data7.sourceRefs === undefined){
const err17 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/projectValidationLineage/required",keyword:"required",params:{missingProperty: "sourceRefs"},message:"must have required property '"+"sourceRefs"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
for(const key1 in data7){
if(!(((key1 === "authorityStatus") || (key1 === "sourceKind")) || (key1 === "sourceRefs"))){
const err18 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/projectValidationLineage/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data7.authorityStatus !== undefined){
if("project-validation" !== data7.authorityStatus){
const err19 = {instancePath:instancePath+"/lineage/authorityStatus",schemaPath:"#/$defs/projectValidationLineage/properties/authorityStatus/const",keyword:"const",params:{allowedValue: "project-validation"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data7.sourceKind !== undefined){
if("project-validation-contract" !== data7.sourceKind){
const err20 = {instancePath:instancePath+"/lineage/sourceKind",schemaPath:"#/$defs/projectValidationLineage/properties/sourceKind/const",keyword:"const",params:{allowedValue: "project-validation-contract"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data7.sourceRefs !== undefined){
let data10 = data7.sourceRefs;
if(Array.isArray(data10)){
if(data10.length > 1){
const err21 = {instancePath:instancePath+"/lineage/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/maxItems",keyword:"maxItems",params:{limit: 1},message:"must NOT have more than 1 items"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data10.length < 1){
const err22 = {instancePath:instancePath+"/lineage/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
const len1 = data10.length;
if(len1 > 0){
if("cogo:project-validation-contract/wonbanking-account-selection-v1" !== data10[0]){
const err23 = {instancePath:instancePath+"/lineage/sourceRefs/0",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/prefixItems/0/const",keyword:"const",params:{allowedValue: "cogo:project-validation-contract/wonbanking-account-selection-v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
const len2 = data10.length;
if(!(len2 <= 1)){
const err24 = {instancePath:instancePath+"/lineage/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/items",keyword:"items",params:{limit: 1},message:"must NOT have more than 1 items"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/lineage/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
else {
const err26 = {instancePath:instancePath+"/lineage",schemaPath:"#/$defs/projectValidationLineage/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
var _valid0 = _errs15 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = props0 || {};
props0.applicationCoreRef = true;
props0.lineage = true;
}
}
}
if(!valid0){
const err27 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schemaVersion === undefined){
const err28 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schemaVersion"},message:"must have required property '"+"schemaVersion"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data.applicationBlueprintId === undefined){
const err29 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "applicationBlueprintId"},message:"must have required property '"+"applicationBlueprintId"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data.version === undefined){
const err30 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(data.applicationCoreRef === undefined){
const err31 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "applicationCoreRef"},message:"must have required property '"+"applicationCoreRef"+"'"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(data.target === undefined){
const err32 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data.locale === undefined){
const err33 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "locale"},message:"must have required property '"+"locale"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data.recipeRef === undefined){
const err34 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "recipeRef"},message:"must have required property '"+"recipeRef"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data.userGoal === undefined){
const err35 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "userGoal"},message:"must have required property '"+"userGoal"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data.actor === undefined){
const err36 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "actor"},message:"must have required property '"+"actor"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data.capabilities === undefined){
const err37 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data.applicationStates === undefined){
const err38 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "applicationStates"},message:"must have required property '"+"applicationStates"+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(data.applicationEvents === undefined){
const err39 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "applicationEvents"},message:"must have required property '"+"applicationEvents"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data.applicationFlows === undefined){
const err40 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "applicationFlows"},message:"must have required property '"+"applicationFlows"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data.datasourceRequirements === undefined){
const err41 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "datasourceRequirements"},message:"must have required property '"+"datasourceRequirements"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data.applicationPorts === undefined){
const err42 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "applicationPorts"},message:"must have required property '"+"applicationPorts"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data.uxInstances === undefined){
const err43 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "uxInstances"},message:"must have required property '"+"uxInstances"+"'"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
if(data.bindings === undefined){
const err44 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bindings"},message:"must have required property '"+"bindings"+"'"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if(data.journey === undefined){
const err45 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "journey"},message:"must have required property '"+"journey"+"'"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
if(data.lineage === undefined){
const err46 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "lineage"},message:"must have required property '"+"lineage"+"'"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
if(data.runtimeCapabilities === undefined){
const err47 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runtimeCapabilities"},message:"must have required property '"+"runtimeCapabilities"+"'"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
for(const key2 in data){
if(!(func1.call(schema31.properties, key2))){
const err48 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data.schemaVersion !== undefined){
if("cogo.application-blueprint.v1" !== data.schemaVersion){
const err49 = {instancePath:instancePath+"/schemaVersion",schemaPath:"#/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.application-blueprint.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
if(data.applicationBlueprintId !== undefined){
let data13 = data.applicationBlueprintId;
if(typeof data13 === "string"){
if(!pattern6.test(data13)){
const err50 = {instancePath:instancePath+"/applicationBlueprintId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
else {
const err51 = {instancePath:instancePath+"/applicationBlueprintId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data.version !== undefined){
let data14 = data.version;
if(typeof data14 === "string"){
if(!pattern7.test(data14)){
const err52 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
else {
const err53 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
if(data.applicationCoreRef !== undefined){
if(typeof data.applicationCoreRef !== "string"){
const err54 = {instancePath:instancePath+"/applicationCoreRef",schemaPath:"#/properties/applicationCoreRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
if(data.target !== undefined){
if("web" !== data.target){
const err55 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/const",keyword:"const",params:{allowedValue: "web"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
if(data.locale !== undefined){
let data17 = data.locale;
if(typeof data17 === "string"){
if(!pattern8.test(data17)){
const err56 = {instancePath:instancePath+"/locale",schemaPath:"#/properties/locale/pattern",keyword:"pattern",params:{pattern: "^[a-z]{2}-[A-Z]{2}$"},message:"must match pattern \""+"^[a-z]{2}-[A-Z]{2}$"+"\""};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
else {
const err57 = {instancePath:instancePath+"/locale",schemaPath:"#/properties/locale/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
if(data.recipeRef !== undefined){
let data18 = data.recipeRef;
if(typeof data18 === "string"){
if(!pattern9.test(data18)){
const err58 = {instancePath:instancePath+"/recipeRef",schemaPath:"#/properties/recipeRef/pattern",keyword:"pattern",params:{pattern: "^cogo:composition-recipe/[A-Za-z0-9._~/-]+$"},message:"must match pattern \""+"^cogo:composition-recipe/[A-Za-z0-9._~/-]+$"+"\""};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
else {
const err59 = {instancePath:instancePath+"/recipeRef",schemaPath:"#/properties/recipeRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
if(data.userGoal !== undefined){
let data19 = data.userGoal;
if(typeof data19 === "string"){
if(func2(data19) < 1){
const err60 = {instancePath:instancePath+"/userGoal",schemaPath:"#/$defs/nonEmpty/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
else {
const err61 = {instancePath:instancePath+"/userGoal",schemaPath:"#/$defs/nonEmpty/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
if(data.actor !== undefined){
let data20 = data.actor;
if(typeof data20 === "string"){
if(!pattern6.test(data20)){
const err62 = {instancePath:instancePath+"/actor",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
}
else {
const err63 = {instancePath:instancePath+"/actor",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
if(data.capabilities !== undefined){
if(!(validate21(data.capabilities, {instancePath:instancePath+"/capabilities",parentData:data,parentDataProperty:"capabilities",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
if(data.applicationStates !== undefined){
let data22 = data.applicationStates;
if(Array.isArray(data22)){
if(data22.length < 1){
const err64 = {instancePath:instancePath+"/applicationStates",schemaPath:"#/properties/applicationStates/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
const len3 = data22.length;
for(let i2=0; i2<len3; i2++){
let data23 = data22[i2];
if(typeof data23 === "string"){
if(!pattern6.test(data23)){
const err65 = {instancePath:instancePath+"/applicationStates/" + i2,schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
}
else {
const err66 = {instancePath:instancePath+"/applicationStates/" + i2,schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
let i3 = data22.length;
let j1;
if(i3 > 1){
outer0:
for(;i3--;){
for(j1 = i3; j1--;){
if(func0(data22[i3], data22[j1])){
const err67 = {instancePath:instancePath+"/applicationStates",schemaPath:"#/properties/applicationStates/uniqueItems",keyword:"uniqueItems",params:{i: i3, j: j1},message:"must NOT have duplicate items (items ## "+j1+" and "+i3+" are identical)"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err68 = {instancePath:instancePath+"/applicationStates",schemaPath:"#/properties/applicationStates/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
}
if(data.applicationEvents !== undefined){
if(!(validate21(data.applicationEvents, {instancePath:instancePath+"/applicationEvents",parentData:data,parentDataProperty:"applicationEvents",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
if(data.applicationFlows !== undefined){
let data25 = data.applicationFlows;
if(Array.isArray(data25)){
const len4 = data25.length;
for(let i4=0; i4<len4; i4++){
if(!(validate24(data25[i4], {instancePath:instancePath+"/applicationFlows/" + i4,parentData:data25,parentDataProperty:i4,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
errors = vErrors.length;
}
}
}
else {
const err69 = {instancePath:instancePath+"/applicationFlows",schemaPath:"#/properties/applicationFlows/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
if(data.datasourceRequirements !== undefined){
let data27 = data.datasourceRequirements;
if(Array.isArray(data27)){
const len5 = data27.length;
for(let i5=0; i5<len5; i5++){
if(!(validate26(data27[i5], {instancePath:instancePath+"/datasourceRequirements/" + i5,parentData:data27,parentDataProperty:i5,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
errors = vErrors.length;
}
}
}
else {
const err70 = {instancePath:instancePath+"/datasourceRequirements",schemaPath:"#/properties/datasourceRequirements/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
if(data.applicationPorts !== undefined){
let data29 = data.applicationPorts;
if(Array.isArray(data29)){
const len6 = data29.length;
for(let i6=0; i6<len6; i6++){
if(!(validate28(data29[i6], {instancePath:instancePath+"/applicationPorts/" + i6,parentData:data29,parentDataProperty:i6,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
errors = vErrors.length;
}
}
}
else {
const err71 = {instancePath:instancePath+"/applicationPorts",schemaPath:"#/properties/applicationPorts/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
}
if(data.uxInstances !== undefined){
let data31 = data.uxInstances;
if(Array.isArray(data31)){
if(data31.length < 1){
const err72 = {instancePath:instancePath+"/uxInstances",schemaPath:"#/properties/uxInstances/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
const len7 = data31.length;
for(let i7=0; i7<len7; i7++){
if(!(validate30(data31[i7], {instancePath:instancePath+"/uxInstances/" + i7,parentData:data31,parentDataProperty:i7,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate30.errors : vErrors.concat(validate30.errors);
errors = vErrors.length;
}
}
}
else {
const err73 = {instancePath:instancePath+"/uxInstances",schemaPath:"#/properties/uxInstances/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
if(data.bindings !== undefined){
let data33 = data.bindings;
if(Array.isArray(data33)){
const len8 = data33.length;
for(let i8=0; i8<len8; i8++){
if(!(validate32(data33[i8], {instancePath:instancePath+"/bindings/" + i8,parentData:data33,parentDataProperty:i8,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
errors = vErrors.length;
}
}
}
else {
const err74 = {instancePath:instancePath+"/bindings",schemaPath:"#/properties/bindings/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
}
if(data.journey !== undefined){
if(!(validate37(data.journey, {instancePath:instancePath+"/journey",parentData:data,parentDataProperty:"journey",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate37.errors : vErrors.concat(validate37.errors);
errors = vErrors.length;
}
}
if(data.lineage !== undefined){
if(!(validate43(data.lineage, {instancePath:instancePath+"/lineage",parentData:data,parentDataProperty:"lineage",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate43.errors : vErrors.concat(validate43.errors);
errors = vErrors.length;
}
}
if(data.runtimeCapabilities !== undefined){
if(!(validate45(data.runtimeCapabilities, {instancePath:instancePath+"/runtimeCapabilities",parentData:data,parentDataProperty:"runtimeCapabilities",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
errors = vErrors.length;
}
}
}
else {
const err75 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
validate20.errors = vErrors;
return errors === 0;
}
validate20.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateUx = validate47;
const schema75 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"urn:cogo:v4:ux-pattern-definition","type":"object","additionalProperties":false,"required":["schemaVersion","uxPatternId","version","target","intent","actorContext","requiredCapabilities","preconditions","postconditions","states","transitions","ports","semanticNodes","lineage"],"properties":{"schemaVersion":{"const":"cogo.ux-pattern-definition.v1"},"uxPatternId":{"$ref":"#/$defs/id"},"version":{"$ref":"#/$defs/version"},"target":{"const":"web"},"intent":{"$ref":"#/$defs/nonEmpty"},"actorContext":{"$ref":"#/$defs/id"},"requiredCapabilities":{"$ref":"#/$defs/uniqueIds"},"preconditions":{"$ref":"#/$defs/uniqueIds"},"postconditions":{"$ref":"#/$defs/uniqueIds"},"states":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/state"}},"transitions":{"type":"array","items":{"$ref":"#/$defs/transition"}},"ports":{"type":"array","items":{"$ref":"#/$defs/port"}},"semanticNodes":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/semanticNode"}},"lineage":{"$ref":"#/$defs/lineage"}},"$defs":{"nonEmpty":{"type":"string","minLength":1},"id":{"type":"string","pattern":"^[a-z][a-z0-9-]*$"},"version":{"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"},"uniqueIds":{"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/id"}},"state":{"type":"object","additionalProperties":false,"required":["stateId","statusIntent"],"properties":{"stateId":{"$ref":"#/$defs/id"},"statusIntent":{"enum":["idle","pending","success","error","retry","cancelled"]}}},"transition":{"type":"object","additionalProperties":false,"required":["transitionId","fromState","eventRef","toState","effectRefs","emitEventRefs"],"properties":{"transitionId":{"$ref":"#/$defs/id"},"fromState":{"$ref":"#/$defs/id"},"eventRef":{"$ref":"#/$defs/id"},"toState":{"$ref":"#/$defs/id"},"effectRefs":{"$ref":"#/$defs/uniqueIds"},"emitEventRefs":{"$ref":"#/$defs/uniqueIds"}}},"port":{"type":"object","additionalProperties":false,"required":["portId","kind","direction","valueType","required"],"properties":{"portId":{"$ref":"#/$defs/id"},"kind":{"enum":["data","event","action"]},"direction":{"enum":["in","out"]},"valueType":{"type":"string","pattern":"^cogo\\.[a-z][a-z0-9.-]*$"},"required":{"type":"boolean"}}},"content":{"type":"object","additionalProperties":false,"properties":{"title":{"$ref":"#/$defs/contentValue"},"description":{"$ref":"#/$defs/contentValue"},"label":{"$ref":"#/$defs/contentValue"},"location":{"$ref":"#/$defs/contentValue"},"pendingLabel":{"$ref":"#/$defs/contentValue"},"successLabel":{"$ref":"#/$defs/contentValue"},"errorLabel":{"$ref":"#/$defs/contentValue"}}},"contentValue":{"type":["string","number","boolean"]},"action":{"type":"object","additionalProperties":false,"required":["role","capabilityRef","slotRef"],"properties":{"role":{"enum":["primary","secondary","recovery","destructive"]},"capabilityRef":{"$ref":"#/$defs/id"},"slotRef":{"$ref":"#/$defs/id"}}},"semanticNode":{"type":"object","additionalProperties":false,"required":["nodeId","semanticRole","regionRef","content","visibleIn"],"properties":{"nodeId":{"$ref":"#/$defs/id"},"semanticRole":{"$ref":"#/$defs/id"},"regionRef":{"$ref":"#/$defs/id"},"content":{"$ref":"#/$defs/content"},"visibleIn":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/id"}},"action":{"$ref":"#/$defs/action"}}},"lineage":{"oneOf":[{"$ref":"#/$defs/canonicalLineage"},{"$ref":"#/$defs/projectValidationLineage"}]},"canonicalLineage":{"type":"object","additionalProperties":false,"required":["authorityStatus","sourceKind","sourceRefs"],"properties":{"authorityStatus":{"const":"consumer-verified"},"sourceKind":{"enum":["admitted-ux-research","human-authored-canonical"]},"sourceRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"type":"string","pattern":"^cogo:(ux-observation|approved-source)/[a-z0-9][a-z0-9-]*$"}}}},"projectValidationLineage":{"type":"object","additionalProperties":false,"required":["authorityStatus","sourceKind","sourceRefs"],"properties":{"authorityStatus":{"const":"project-validation"},"sourceKind":{"const":"project-validation-contract"},"sourceRefs":{"type":"array","minItems":1,"maxItems":1,"prefixItems":[{"const":"cogo:project-validation-contract/wonbanking-account-selection-v1"}],"items":false}}}}};
const schema76 = {"type":"string","pattern":"^[a-z][a-z0-9-]*$"};
const schema77 = {"type":"string","pattern":"^[0-9]+\\.[0-9]+\\.[0-9]+$"};
const schema78 = {"type":"string","minLength":1};
const schema80 = {"type":"array","uniqueItems":true,"items":{"$ref":"#/$defs/id"}};

function validate48(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate48.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(Array.isArray(data)){
const len0 = data.length;
for(let i0=0; i0<len0; i0++){
let data0 = data[i0];
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err0 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
else {
const err1 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
let i1 = data.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data[i1], data[j0])){
const err2 = {instancePath,schemaPath:"#/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err3 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
validate48.errors = vErrors;
return errors === 0;
}
validate48.evaluated = {"items":true,"dynamicProps":false,"dynamicItems":false};

const schema82 = {"type":"object","additionalProperties":false,"required":["stateId","statusIntent"],"properties":{"stateId":{"$ref":"#/$defs/id"},"statusIntent":{"enum":["idle","pending","success","error","retry","cancelled"]}}};

function validate52(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate52.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.stateId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "stateId"},message:"must have required property '"+"stateId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.statusIntent === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "statusIntent"},message:"must have required property '"+"statusIntent"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "stateId") || (key0 === "statusIntent"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.stateId !== undefined){
let data0 = data.stateId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err3 = {instancePath:instancePath+"/stateId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/stateId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.statusIntent !== undefined){
let data1 = data.statusIntent;
if(!((((((data1 === "idle") || (data1 === "pending")) || (data1 === "success")) || (data1 === "error")) || (data1 === "retry")) || (data1 === "cancelled"))){
const err5 = {instancePath:instancePath+"/statusIntent",schemaPath:"#/properties/statusIntent/enum",keyword:"enum",params:{allowedValues: schema82.properties.statusIntent.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate52.errors = vErrors;
return errors === 0;
}
validate52.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema84 = {"type":"object","additionalProperties":false,"required":["transitionId","fromState","eventRef","toState","effectRefs","emitEventRefs"],"properties":{"transitionId":{"$ref":"#/$defs/id"},"fromState":{"$ref":"#/$defs/id"},"eventRef":{"$ref":"#/$defs/id"},"toState":{"$ref":"#/$defs/id"},"effectRefs":{"$ref":"#/$defs/uniqueIds"},"emitEventRefs":{"$ref":"#/$defs/uniqueIds"}}};

function validate54(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate54.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.transitionId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "transitionId"},message:"must have required property '"+"transitionId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.fromState === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fromState"},message:"must have required property '"+"fromState"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.eventRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "eventRef"},message:"must have required property '"+"eventRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.toState === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "toState"},message:"must have required property '"+"toState"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.effectRefs === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "effectRefs"},message:"must have required property '"+"effectRefs"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.emitEventRefs === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "emitEventRefs"},message:"must have required property '"+"emitEventRefs"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "transitionId") || (key0 === "fromState")) || (key0 === "eventRef")) || (key0 === "toState")) || (key0 === "effectRefs")) || (key0 === "emitEventRefs"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.transitionId !== undefined){
let data0 = data.transitionId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err7 = {instancePath:instancePath+"/transitionId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/transitionId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.fromState !== undefined){
let data1 = data.fromState;
if(typeof data1 === "string"){
if(!pattern6.test(data1)){
const err9 = {instancePath:instancePath+"/fromState",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/fromState",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.eventRef !== undefined){
let data2 = data.eventRef;
if(typeof data2 === "string"){
if(!pattern6.test(data2)){
const err11 = {instancePath:instancePath+"/eventRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/eventRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.toState !== undefined){
let data3 = data.toState;
if(typeof data3 === "string"){
if(!pattern6.test(data3)){
const err13 = {instancePath:instancePath+"/toState",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/toState",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.effectRefs !== undefined){
if(!(validate48(data.effectRefs, {instancePath:instancePath+"/effectRefs",parentData:data,parentDataProperty:"effectRefs",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
errors = vErrors.length;
}
}
if(data.emitEventRefs !== undefined){
if(!(validate48(data.emitEventRefs, {instancePath:instancePath+"/emitEventRefs",parentData:data,parentDataProperty:"emitEventRefs",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
errors = vErrors.length;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate54.errors = vErrors;
return errors === 0;
}
validate54.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema89 = {"type":"object","additionalProperties":false,"required":["portId","kind","direction","valueType","required"],"properties":{"portId":{"$ref":"#/$defs/id"},"kind":{"enum":["data","event","action"]},"direction":{"enum":["in","out"]},"valueType":{"type":"string","pattern":"^cogo\\.[a-z][a-z0-9.-]*$"},"required":{"type":"boolean"}}};

function validate58(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate58.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.portId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "portId"},message:"must have required property '"+"portId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.direction === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "direction"},message:"must have required property '"+"direction"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.valueType === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "valueType"},message:"must have required property '"+"valueType"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.required === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "required"},message:"must have required property '"+"required"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "portId") || (key0 === "kind")) || (key0 === "direction")) || (key0 === "valueType")) || (key0 === "required"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.portId !== undefined){
let data0 = data.portId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err6 = {instancePath:instancePath+"/portId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/portId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(!(((data1 === "data") || (data1 === "event")) || (data1 === "action"))){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema89.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.direction !== undefined){
let data2 = data.direction;
if(!((data2 === "in") || (data2 === "out"))){
const err9 = {instancePath:instancePath+"/direction",schemaPath:"#/properties/direction/enum",keyword:"enum",params:{allowedValues: schema89.properties.direction.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.valueType !== undefined){
let data3 = data.valueType;
if(typeof data3 === "string"){
if(!pattern19.test(data3)){
const err10 = {instancePath:instancePath+"/valueType",schemaPath:"#/properties/valueType/pattern",keyword:"pattern",params:{pattern: "^cogo\\.[a-z][a-z0-9.-]*$"},message:"must match pattern \""+"^cogo\\.[a-z][a-z0-9.-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/valueType",schemaPath:"#/properties/valueType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.required !== undefined){
if(typeof data.required !== "boolean"){
const err12 = {instancePath:instancePath+"/required",schemaPath:"#/properties/required/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate58.errors = vErrors;
return errors === 0;
}
validate58.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema91 = {"type":"object","additionalProperties":false,"required":["nodeId","semanticRole","regionRef","content","visibleIn"],"properties":{"nodeId":{"$ref":"#/$defs/id"},"semanticRole":{"$ref":"#/$defs/id"},"regionRef":{"$ref":"#/$defs/id"},"content":{"$ref":"#/$defs/content"},"visibleIn":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/id"}},"action":{"$ref":"#/$defs/action"}}};
const schema95 = {"type":"object","additionalProperties":false,"properties":{"title":{"$ref":"#/$defs/contentValue"},"description":{"$ref":"#/$defs/contentValue"},"label":{"$ref":"#/$defs/contentValue"},"location":{"$ref":"#/$defs/contentValue"},"pendingLabel":{"$ref":"#/$defs/contentValue"},"successLabel":{"$ref":"#/$defs/contentValue"},"errorLabel":{"$ref":"#/$defs/contentValue"}}};
const schema96 = {"type":["string","number","boolean"]};

function validate61(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate61.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(!(((((((key0 === "title") || (key0 === "description")) || (key0 === "label")) || (key0 === "location")) || (key0 === "pendingLabel")) || (key0 === "successLabel")) || (key0 === "errorLabel"))){
const err0 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data.title !== undefined){
let data0 = data.title;
if(((typeof data0 !== "string") && (!(typeof data0 == "number"))) && (typeof data0 !== "boolean")){
const err1 = {instancePath:instancePath+"/title",schemaPath:"#/$defs/contentValue/type",keyword:"type",params:{type: schema96.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.description !== undefined){
let data1 = data.description;
if(((typeof data1 !== "string") && (!(typeof data1 == "number"))) && (typeof data1 !== "boolean")){
const err2 = {instancePath:instancePath+"/description",schemaPath:"#/$defs/contentValue/type",keyword:"type",params:{type: schema96.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.label !== undefined){
let data2 = data.label;
if(((typeof data2 !== "string") && (!(typeof data2 == "number"))) && (typeof data2 !== "boolean")){
const err3 = {instancePath:instancePath+"/label",schemaPath:"#/$defs/contentValue/type",keyword:"type",params:{type: schema96.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.location !== undefined){
let data3 = data.location;
if(((typeof data3 !== "string") && (!(typeof data3 == "number"))) && (typeof data3 !== "boolean")){
const err4 = {instancePath:instancePath+"/location",schemaPath:"#/$defs/contentValue/type",keyword:"type",params:{type: schema96.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.pendingLabel !== undefined){
let data4 = data.pendingLabel;
if(((typeof data4 !== "string") && (!(typeof data4 == "number"))) && (typeof data4 !== "boolean")){
const err5 = {instancePath:instancePath+"/pendingLabel",schemaPath:"#/$defs/contentValue/type",keyword:"type",params:{type: schema96.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.successLabel !== undefined){
let data5 = data.successLabel;
if(((typeof data5 !== "string") && (!(typeof data5 == "number"))) && (typeof data5 !== "boolean")){
const err6 = {instancePath:instancePath+"/successLabel",schemaPath:"#/$defs/contentValue/type",keyword:"type",params:{type: schema96.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.errorLabel !== undefined){
let data6 = data.errorLabel;
if(((typeof data6 !== "string") && (!(typeof data6 == "number"))) && (typeof data6 !== "boolean")){
const err7 = {instancePath:instancePath+"/errorLabel",schemaPath:"#/$defs/contentValue/type",keyword:"type",params:{type: schema96.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate61.errors = vErrors;
return errors === 0;
}
validate61.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema104 = {"type":"object","additionalProperties":false,"required":["role","capabilityRef","slotRef"],"properties":{"role":{"enum":["primary","secondary","recovery","destructive"]},"capabilityRef":{"$ref":"#/$defs/id"},"slotRef":{"$ref":"#/$defs/id"}}};

function validate63(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate63.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.role === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.capabilityRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilityRef"},message:"must have required property '"+"capabilityRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.slotRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "slotRef"},message:"must have required property '"+"slotRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "role") || (key0 === "capabilityRef")) || (key0 === "slotRef"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.role !== undefined){
let data0 = data.role;
if(!((((data0 === "primary") || (data0 === "secondary")) || (data0 === "recovery")) || (data0 === "destructive"))){
const err4 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/enum",keyword:"enum",params:{allowedValues: schema104.properties.role.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.capabilityRef !== undefined){
let data1 = data.capabilityRef;
if(typeof data1 === "string"){
if(!pattern6.test(data1)){
const err5 = {instancePath:instancePath+"/capabilityRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/capabilityRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.slotRef !== undefined){
let data2 = data.slotRef;
if(typeof data2 === "string"){
if(!pattern6.test(data2)){
const err7 = {instancePath:instancePath+"/slotRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/slotRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate63.errors = vErrors;
return errors === 0;
}
validate63.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate60(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate60.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nodeId"},message:"must have required property '"+"nodeId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.semanticRole === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "semanticRole"},message:"must have required property '"+"semanticRole"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.regionRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "regionRef"},message:"must have required property '"+"regionRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.content === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "content"},message:"must have required property '"+"content"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.visibleIn === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "visibleIn"},message:"must have required property '"+"visibleIn"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "nodeId") || (key0 === "semanticRole")) || (key0 === "regionRef")) || (key0 === "content")) || (key0 === "visibleIn")) || (key0 === "action"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.nodeId !== undefined){
let data0 = data.nodeId;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err6 = {instancePath:instancePath+"/nodeId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/nodeId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.semanticRole !== undefined){
let data1 = data.semanticRole;
if(typeof data1 === "string"){
if(!pattern6.test(data1)){
const err8 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.regionRef !== undefined){
let data2 = data.regionRef;
if(typeof data2 === "string"){
if(!pattern6.test(data2)){
const err10 = {instancePath:instancePath+"/regionRef",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/regionRef",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.content !== undefined){
if(!(validate61(data.content, {instancePath:instancePath+"/content",parentData:data,parentDataProperty:"content",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate61.errors : vErrors.concat(validate61.errors);
errors = vErrors.length;
}
}
if(data.visibleIn !== undefined){
let data4 = data.visibleIn;
if(Array.isArray(data4)){
if(data4.length < 1){
const err12 = {instancePath:instancePath+"/visibleIn",schemaPath:"#/properties/visibleIn/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
const len0 = data4.length;
for(let i0=0; i0<len0; i0++){
let data5 = data4[i0];
if(typeof data5 === "string"){
if(!pattern6.test(data5)){
const err13 = {instancePath:instancePath+"/visibleIn/" + i0,schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/visibleIn/" + i0,schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
let i1 = data4.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data4[i1], data4[j0])){
const err15 = {instancePath:instancePath+"/visibleIn",schemaPath:"#/properties/visibleIn/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err16 = {instancePath:instancePath+"/visibleIn",schemaPath:"#/properties/visibleIn/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.action !== undefined){
if(!(validate63(data.action, {instancePath:instancePath+"/action",parentData:data,parentDataProperty:"action",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
errors = vErrors.length;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate60.errors = vErrors;
return errors === 0;
}
validate60.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema107 = {"oneOf":[{"$ref":"#/$defs/canonicalLineage"},{"$ref":"#/$defs/projectValidationLineage"}]};
const schema108 = {"type":"object","additionalProperties":false,"required":["authorityStatus","sourceKind","sourceRefs"],"properties":{"authorityStatus":{"const":"consumer-verified"},"sourceKind":{"enum":["admitted-ux-research","human-authored-canonical"]},"sourceRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"type":"string","pattern":"^cogo:(ux-observation|approved-source)/[a-z0-9][a-z0-9-]*$"}}}};
const schema109 = {"type":"object","additionalProperties":false,"required":["authorityStatus","sourceKind","sourceRefs"],"properties":{"authorityStatus":{"const":"project-validation"},"sourceKind":{"const":"project-validation-contract"},"sourceRefs":{"type":"array","minItems":1,"maxItems":1,"prefixItems":[{"const":"cogo:project-validation-contract/wonbanking-account-selection-v1"}],"items":false}}};
const pattern54 = new RegExp("^cogo:(ux-observation|approved-source)/[a-z0-9][a-z0-9-]*$", "u");

function validate66(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate66.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authorityStatus === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/canonicalLineage/required",keyword:"required",params:{missingProperty: "authorityStatus"},message:"must have required property '"+"authorityStatus"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.sourceKind === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/canonicalLineage/required",keyword:"required",params:{missingProperty: "sourceKind"},message:"must have required property '"+"sourceKind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.sourceRefs === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/canonicalLineage/required",keyword:"required",params:{missingProperty: "sourceRefs"},message:"must have required property '"+"sourceRefs"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "authorityStatus") || (key0 === "sourceKind")) || (key0 === "sourceRefs"))){
const err3 = {instancePath,schemaPath:"#/$defs/canonicalLineage/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.authorityStatus !== undefined){
if("consumer-verified" !== data.authorityStatus){
const err4 = {instancePath:instancePath+"/authorityStatus",schemaPath:"#/$defs/canonicalLineage/properties/authorityStatus/const",keyword:"const",params:{allowedValue: "consumer-verified"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.sourceKind !== undefined){
let data1 = data.sourceKind;
if(!((data1 === "admitted-ux-research") || (data1 === "human-authored-canonical"))){
const err5 = {instancePath:instancePath+"/sourceKind",schemaPath:"#/$defs/canonicalLineage/properties/sourceKind/enum",keyword:"enum",params:{allowedValues: schema108.properties.sourceKind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.sourceRefs !== undefined){
let data2 = data.sourceRefs;
if(Array.isArray(data2)){
if(data2.length < 1){
const err6 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
let data3 = data2[i0];
if(typeof data3 === "string"){
if(!pattern54.test(data3)){
const err7 = {instancePath:instancePath+"/sourceRefs/" + i0,schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/items/pattern",keyword:"pattern",params:{pattern: "^cogo:(ux-observation|approved-source)/[a-z0-9][a-z0-9-]*$"},message:"must match pattern \""+"^cogo:(ux-observation|approved-source)/[a-z0-9][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/sourceRefs/" + i0,schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
let i1 = data2.length;
let j0;
if(i1 > 1){
const indices0 = {};
for(;i1--;){
let item0 = data2[i1];
if(typeof item0 !== "string"){
continue;
}
if(typeof indices0[item0] == "number"){
j0 = indices0[item0];
const err9 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
break;
}
indices0[item0] = i1;
}
}
}
else {
const err10 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/canonicalLineage/properties/sourceRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
else {
const err11 = {instancePath,schemaPath:"#/$defs/canonicalLineage/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs11 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authorityStatus === undefined){
const err12 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/required",keyword:"required",params:{missingProperty: "authorityStatus"},message:"must have required property '"+"authorityStatus"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.sourceKind === undefined){
const err13 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/required",keyword:"required",params:{missingProperty: "sourceKind"},message:"must have required property '"+"sourceKind"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data.sourceRefs === undefined){
const err14 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/required",keyword:"required",params:{missingProperty: "sourceRefs"},message:"must have required property '"+"sourceRefs"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
for(const key1 in data){
if(!(((key1 === "authorityStatus") || (key1 === "sourceKind")) || (key1 === "sourceRefs"))){
const err15 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.authorityStatus !== undefined){
if("project-validation" !== data.authorityStatus){
const err16 = {instancePath:instancePath+"/authorityStatus",schemaPath:"#/$defs/projectValidationLineage/properties/authorityStatus/const",keyword:"const",params:{allowedValue: "project-validation"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.sourceKind !== undefined){
if("project-validation-contract" !== data.sourceKind){
const err17 = {instancePath:instancePath+"/sourceKind",schemaPath:"#/$defs/projectValidationLineage/properties/sourceKind/const",keyword:"const",params:{allowedValue: "project-validation-contract"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.sourceRefs !== undefined){
let data6 = data.sourceRefs;
if(Array.isArray(data6)){
if(data6.length > 1){
const err18 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/maxItems",keyword:"maxItems",params:{limit: 1},message:"must NOT have more than 1 items"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data6.length < 1){
const err19 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
const len1 = data6.length;
if(len1 > 0){
if("cogo:project-validation-contract/wonbanking-account-selection-v1" !== data6[0]){
const err20 = {instancePath:instancePath+"/sourceRefs/0",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/prefixItems/0/const",keyword:"const",params:{allowedValue: "cogo:project-validation-contract/wonbanking-account-selection-v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
const len2 = data6.length;
if(!(len2 <= 1)){
const err21 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/items",keyword:"items",params:{limit: 1},message:"must NOT have more than 1 items"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/$defs/projectValidationLineage/properties/sourceRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/$defs/projectValidationLineage/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
var _valid0 = _errs11 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err24 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate66.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate66.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate47(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="urn:cogo:v4:ux-pattern-definition" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate47.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schemaVersion === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schemaVersion"},message:"must have required property '"+"schemaVersion"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.uxPatternId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "uxPatternId"},message:"must have required property '"+"uxPatternId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.version === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.target === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.intent === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "intent"},message:"must have required property '"+"intent"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.actorContext === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "actorContext"},message:"must have required property '"+"actorContext"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.requiredCapabilities === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requiredCapabilities"},message:"must have required property '"+"requiredCapabilities"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.preconditions === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "preconditions"},message:"must have required property '"+"preconditions"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.postconditions === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "postconditions"},message:"must have required property '"+"postconditions"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.states === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "states"},message:"must have required property '"+"states"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.transitions === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "transitions"},message:"must have required property '"+"transitions"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.ports === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ports"},message:"must have required property '"+"ports"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.semanticNodes === undefined){
const err12 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "semanticNodes"},message:"must have required property '"+"semanticNodes"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.lineage === undefined){
const err13 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "lineage"},message:"must have required property '"+"lineage"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema75.properties, key0))){
const err14 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.schemaVersion !== undefined){
if("cogo.ux-pattern-definition.v1" !== data.schemaVersion){
const err15 = {instancePath:instancePath+"/schemaVersion",schemaPath:"#/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.ux-pattern-definition.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.uxPatternId !== undefined){
let data1 = data.uxPatternId;
if(typeof data1 === "string"){
if(!pattern6.test(data1)){
const err16 = {instancePath:instancePath+"/uxPatternId",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/uxPatternId",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.version !== undefined){
let data2 = data.version;
if(typeof data2 === "string"){
if(!pattern7.test(data2)){
const err18 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/pattern",keyword:"pattern",params:{pattern: "^[0-9]+\\.[0-9]+\\.[0-9]+$"},message:"must match pattern \""+"^[0-9]+\\.[0-9]+\\.[0-9]+$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/version",schemaPath:"#/$defs/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.target !== undefined){
if("web" !== data.target){
const err20 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/const",keyword:"const",params:{allowedValue: "web"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.intent !== undefined){
let data4 = data.intent;
if(typeof data4 === "string"){
if(func2(data4) < 1){
const err21 = {instancePath:instancePath+"/intent",schemaPath:"#/$defs/nonEmpty/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/intent",schemaPath:"#/$defs/nonEmpty/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.actorContext !== undefined){
let data5 = data.actorContext;
if(typeof data5 === "string"){
if(!pattern6.test(data5)){
const err23 = {instancePath:instancePath+"/actorContext",schemaPath:"#/$defs/id/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9-]*$"},message:"must match pattern \""+"^[a-z][a-z0-9-]*$"+"\""};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/actorContext",schemaPath:"#/$defs/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.requiredCapabilities !== undefined){
if(!(validate48(data.requiredCapabilities, {instancePath:instancePath+"/requiredCapabilities",parentData:data,parentDataProperty:"requiredCapabilities",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
errors = vErrors.length;
}
}
if(data.preconditions !== undefined){
if(!(validate48(data.preconditions, {instancePath:instancePath+"/preconditions",parentData:data,parentDataProperty:"preconditions",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
errors = vErrors.length;
}
}
if(data.postconditions !== undefined){
if(!(validate48(data.postconditions, {instancePath:instancePath+"/postconditions",parentData:data,parentDataProperty:"postconditions",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
errors = vErrors.length;
}
}
if(data.states !== undefined){
let data9 = data.states;
if(Array.isArray(data9)){
if(data9.length < 1){
const err25 = {instancePath:instancePath+"/states",schemaPath:"#/properties/states/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
const len0 = data9.length;
for(let i0=0; i0<len0; i0++){
if(!(validate52(data9[i0], {instancePath:instancePath+"/states/" + i0,parentData:data9,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate52.errors : vErrors.concat(validate52.errors);
errors = vErrors.length;
}
}
}
else {
const err26 = {instancePath:instancePath+"/states",schemaPath:"#/properties/states/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.transitions !== undefined){
let data11 = data.transitions;
if(Array.isArray(data11)){
const len1 = data11.length;
for(let i1=0; i1<len1; i1++){
if(!(validate54(data11[i1], {instancePath:instancePath+"/transitions/" + i1,parentData:data11,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
errors = vErrors.length;
}
}
}
else {
const err27 = {instancePath:instancePath+"/transitions",schemaPath:"#/properties/transitions/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.ports !== undefined){
let data13 = data.ports;
if(Array.isArray(data13)){
const len2 = data13.length;
for(let i2=0; i2<len2; i2++){
if(!(validate58(data13[i2], {instancePath:instancePath+"/ports/" + i2,parentData:data13,parentDataProperty:i2,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate58.errors : vErrors.concat(validate58.errors);
errors = vErrors.length;
}
}
}
else {
const err28 = {instancePath:instancePath+"/ports",schemaPath:"#/properties/ports/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.semanticNodes !== undefined){
let data15 = data.semanticNodes;
if(Array.isArray(data15)){
if(data15.length < 1){
const err29 = {instancePath:instancePath+"/semanticNodes",schemaPath:"#/properties/semanticNodes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
const len3 = data15.length;
for(let i3=0; i3<len3; i3++){
if(!(validate60(data15[i3], {instancePath:instancePath+"/semanticNodes/" + i3,parentData:data15,parentDataProperty:i3,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
errors = vErrors.length;
}
}
}
else {
const err30 = {instancePath:instancePath+"/semanticNodes",schemaPath:"#/properties/semanticNodes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.lineage !== undefined){
if(!(validate66(data.lineage, {instancePath:instancePath+"/lineage",parentData:data,parentDataProperty:"lineage",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate66.errors : vErrors.concat(validate66.errors);
errors = vErrors.length;
}
}
}
else {
const err31 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
validate47.errors = vErrors;
return errors === 0;
}
validate47.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};
